import React, { Component, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  Delete as DeleteIcon,
} from "@material-ui/icons";
import { Icon } from "@material-ui/core";
import cloneDeep from 'lodash/cloneDeep';

export default class DraggableWidgetsList extends React.Component {
    
    constructor(props){
        super(props);

        this.indexOver = -1;
    }

    componentDidMount(){
        this.setState(this.props.state);
    }

    reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      return result;
    };

    onDragEnd(result) {
      if (!result.destination) {
        return;
      }
  
      const items = this.reorder(
        this.state.items,
        result.source.index,
        result.destination.index
      );
  
      this.setState({
        items
      });

      this.props.onChangeOrder(items);
    }

    getItemStyle = (isDragging, draggableStyle, index) => ({
        position: 'relative',
        userSelect: "none",
        padding: 20,
        border: '1px solid #cccccc',
        borderTop: index == 0 ? '1px solid #cccccc' : '0px solid',
        background: isDragging ? "lightgreen" : "transparent",
        ...draggableStyle
      });
    
      getListStyle = isDraggingOver => ({
        background: isDraggingOver ? "lightblue" : "transparent",
        padding: this.grid,
        width: 450
      });

      
    render (){

        if (this.state === null) return <div />;

        return (
        <DragDropContext onDragEnd={this.onDragEnd.bind(this)}>
        <Droppable droppableId="droppable" >
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={this.getListStyle(snapshot.isDraggingOver)}
            >
              {this.state.items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div onMouseEnter={(e) => this.setState({indexOver: index}) }
                          onMouseLeave={(e) => {this.setState({indexOver: -1}) }}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={this.getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style, index
                      )}
                    >
                      {item.content}                      
                      <div onClick={() =>{
                        this.tempItems = cloneDeep(this.state.items)
                        this.tempItems.splice(index, 1);                        
                        if (window.confirm("Sei sicuro di voler eliminare l'elemento")) 
                        {
                          this.setState({items: this.tempItems})
                          this.props.onChangeOrder(this.tempItems)
                        }             
                     }}
                          style={{
                            display: this.state.indexOver === index ? 'block' : 'none',
                            position: 'absolute',
                            right: '10px',
                            top: '40%',
                            height: '100%'                   
                            }}>
                            <DeleteIcon />
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext> ); 
    }

}